import { useState, useRef, useEffect } from "react";
import Slider from "react-slick";

const BannerVideoPlayer = () => {
  const [sliders, setSliders] = useState([]);
  const [mutedVideos, setMutedVideos] = useState({});
  const videoRefs = useRef({});
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    fetchSliders();
  }, []);

  const fetchSliders = async () => {
    try {
      const res = await fetch(`${baseURL}/api/v2/sliders/web`);
      const json = await res.json();

      if (json?.data?.sliders) {
        const sorted = json.data.sliders.sort(
          (a, b) => a.sort_order - b.sort_order
        );
        setSliders(sorted);
      }
    } catch (err) {
      console.log("Slider API error:", err);
    }
  };

  // toggle mute per video
  const toggleMute = (id) => {
    const video = videoRefs.current[id];
    if (!video) return;

    video.muted = !video.muted;

    setMutedVideos((prev) => ({
      ...prev,
      [id]: video.muted,
    }));
  };

  const settings = {
    dots: sliders.length > 1,
    infinite: sliders.length > 1,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 5000,
    arrows: sliders.length > 1,
    pauseOnHover: true,
    pauseOnFocus: true,
    dotsClass: "slick-dots custom-dots", // custom styling
  };

  return (
    <div className="relative w-full mb-10">
      <Slider {...settings}>
        {sliders.map((item) => {
          const mediaUrl =
            `${baseURL}/slider_images/` + item.slider_image;

          return (
            <div key={item.id} className="relative">
              
              {/* VIDEO */}
              {item.media_type === "video" ? (
                <>
                  <video
                    ref={(el) => (videoRefs.current[item.id] = el)}
                    src={mediaUrl}
                    loop
                    muted
                    autoPlay
                    playsInline
                    className="w-full object-cover"
                  />

                  {/* MUTE BUTTON */}
                  <button
                    onClick={() => toggleMute(item.id)}
                    className="absolute bottom-5 right-5 bg-white/10 backdrop-blur-md 
                    border border-white/20 text-white rounded-full p-3 
                    shadow-xl hover:scale-110 transition-all duration-300"
                  >
                    {mutedVideos[item.id] !== false ? (
                      // MUTED ICON
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
                        />
                      </svg>
                    ) : (
                      // UNMUTED ICON
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
                        />
                      </svg>
                    )}
                  </button>
                </>
              ) : (
                // IMAGE
                <img
                  src={mediaUrl}
                  alt={item.slider_heading}
                  className="w-full object-cover"
                />
              )}
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default BannerVideoPlayer;